<template>
  <AppIcon
    :icon="copied ? 'mdi:clipboard-check-outline' : 'mdi:clipboard-text-outline'"
    size="large"
    @click="copy"
  />
</template>

<script setup lang="ts">
import { snackbarInjectionKey } from '~/assets/injection-keys';

const snackbar = inject(snackbarInjectionKey)!;
const props = defineProps<{
  value: string;
  msg: string;
}>();

const copied = ref(false);

function copy() {
  navigator.clipboard.writeText(props.value);
  copied.value = true;
  snackbar.value!.showSuccess(props.msg);
  setTimeout(() => copied.value = false, 2000);
}
</script>